'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadl';
var iconName = 'binary';
var width = 384;
var height = 512;
var aliases = [];
var unicode = 'e33b';
var svgPathData = ['', 'M320 16c0-5.1-2.5-10-6.6-13s-9.5-3.8-14.4-2.2l-48 16c-8.4 2.8-12.9 11.9-10.1 20.2s11.9 12.9 20.2 10.1l26.9-9L288 192l-48 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l64 0 64 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-48 0 0-176zM96 304c0-5.1-2.5-10-6.6-13s-9.5-3.8-14.4-2.2l-48 16c-8.4 2.8-12.9 11.9-10.1 20.2s11.9 12.9 20.2 10.1l26.9-9L64 480l-48 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l64 0 64 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-48 0 0-176zM0 80l0 64c0 44.2 35.8 80 80 80l32 0c44.2 0 80-35.8 80-80l0-64c0-44.2-35.8-80-80-80L80 0C35.8 0 0 35.8 0 80zM80 32l32 0c26.5 0 48 21.5 48 48l0 64c0 26.5-21.5 48-48 48l-32 0c-26.5 0-48-21.5-48-48l0-64c0-26.5 21.5-48 48-48zM272 288c-44.2 0-80 35.8-80 80l0 64c0 44.2 35.8 80 80 80l32 0c44.2 0 80-35.8 80-80l0-64c0-44.2-35.8-80-80-80l-32 0zm-48 80c0-26.5 21.5-48 48-48l32 0c26.5 0 48 21.5 48 48l0 64c0 26.5-21.5 48-48 48l-32 0c-26.5 0-48-21.5-48-48l0-64z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faBinary = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;